export default __webpack_public_path__ + "static/media/cp_geo_no.c1784c5e.svg";